import { ListDisplayGroups, ListDisplayGroupsVariables } from './__generated__/ListDisplayGroups'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

export const LIST_DISPLAY_GROUPS_QUERY = gql`
  query ListDisplayGroups($input: ListDisplayGroupsInputV2) {
    listDisplayGroups: listDisplayGroupsV2(input: $input) {
      displayGroups {
        id
        boards {
          id
        }
        boardStyle
        columns
        rows
        createdAt
        title
      }
      nextCursor
    }
  }
`

export const useListDisplayGroups = (variables: ListDisplayGroupsVariables) => {
  return useQuery<ListDisplayGroups>(LIST_DISPLAY_GROUPS_QUERY, {
    variables,
    fetchPolicy: 'cache-first'
  })
}
